import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type JSX } from 'react';
import { Toaster } from 'sonner';

import { useSession } from './features/auth/use-session.js';
import { AuthPage } from './features/auth/auth-page.js';
import { CockpitPage } from './routes/cockpit-page.js';

function CockpitShell(): JSX.Element {
  const session = useSession();

  if (session.isLoading) {
    return (
      <div
        data-testid="session-loading"
        className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-400 text-sm font-medium"
      >
        <div className="flex items-center gap-3">
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-cyan-500 border-t-transparent" />
          <span>Weryfikacja sesji użytkownika…</span>
        </div>
      </div>
    );
  }

  if (!session.isAuthenticated) {
    return <AuthPage onAuthenticated={session.setSessionToken} />;
  }

  return <CockpitPage session={session} />;
}

/**
 * Desktop cockpit shell (ADR-005): fixed PC layout 1920x1080 / 1440x900,
 * deliberately NO responsive breakpoints. TanStack Query is provided here.
 */
export function App(): JSX.Element {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <CockpitShell />
      <Toaster theme="dark" position="bottom-right" />
    </QueryClientProvider>
  );
}
